export default () => {
  var modalLocket = document.getElementById('modalLocket')
  if ( modalLocket ) {
    modalLocket.addEventListener('show.bs.modal', function (event) {
      const button = event.relatedTarget

      const getModalId = button.getAttribute('data-modal-locket-id')
      const modal = document.getElementById(`${getModalId}`)

      if (modal.querySelector('.js--locket-figure')) {
        const figure = modal.querySelector('.js--locket-figure').getAttribute('src')
        const locketFigure = modalLocket.querySelector('.js--locket-modal-figure')
        locketFigure.setAttribute('src', figure)
      }

      if (button) {
        const name = button.innerText
        const locketName = modalLocket.querySelector('.js--locket-modal-title')
        locketName.textContent = name
      }

      if (modal.querySelector('.js--locket-position')) {
        const position = modal.querySelector('.js--locket-position').innerText
        const locketPosition = modalLocket.querySelector('.js--locket-modal-position')
        locketPosition.textContent = position
      }

      if (modal.querySelector('.js--locket-mail')) {
        const mail = modal.querySelector('.js--locket-mail').innerText
        const locketMail = modalLocket.querySelector('.js--locket-modal-mail')
        locketMail.textContent = mail
        locketMail.setAttribute('href', `mailto:${mail}`)
      }

      const perex = modal.querySelector('.js--locket-perex')
      if (perex) {
        const perexCopy = perex.cloneNode(true)
        const locketPerex = modalLocket.querySelector('.js--locket-modal-perex')
        locketPerex.innerHTML = '';
        locketPerex.appendChild(perexCopy)
      }
    })
  }
}
